import {parameterize} from 'src/shared/utils/parameterize';
export const appendParams = (base, params) => {
  const query = parameterize(params);
  if (query) {
    return `${base}${base.includes('?') ? '&' : '?'}${query}`;
  }
  return base;
};
